<template>
  <div v-show="this.$store.state.alert_show" class="alert alert-danger">
    <span v-for="(error, index) in $store.state.alert_text" :key="error.value">
      {{ error }}
      <br :v-if="index + 1 < $store.state.alert_text.length" />
    </span>
  </div>
</template>

<script>
export default {
  watch: {
    $route() {
      this.$store.dispatch("RESET_ALERT");
    }
  }
};
</script>

<style></style>
